// Build win/loss standings from a flat list of doubles match docs.
// Each match: { teamA: [uidA, uidB], teamB: [uidC, uidD], winningTeam: 'A' | 'B' | null }.
// winningTeam null = draw. All 4 players on a match get credited.
// Players with no recorded games are ranked last (sentinel winPct -1) rather than seeded at 0,
// so a single loss doesn't rank someone below a total newcomer.
export function computeStandings(matches, playerIds, playerNames) {
  var stats = {};
  function ensure(uid) {
    if (!stats[uid]) {
      stats[uid] = { uid: uid, name: (playerNames && playerNames[uid]) || uid, wins: 0, losses: 0, draws: 0, games: 0 };
    }
  }
  playerIds.forEach(ensure);

  matches.forEach(function (m) {
    if (!m.teamA || !m.teamB) return;
    var teamA = m.teamA, teamB = m.teamB;
    teamA.concat(teamB).forEach(ensure);

    teamA.concat(teamB).forEach(function (uid) { stats[uid].games++; });

    if (!m.winningTeam) {
      teamA.concat(teamB).forEach(function (uid) { stats[uid].draws++; });
    } else {
      var winners = m.winningTeam === "A" ? teamA : teamB;
      var losers = m.winningTeam === "A" ? teamB : teamA;
      winners.forEach(function (uid) { stats[uid].wins++; });
      losers.forEach(function (uid) { stats[uid].losses++; });
    }
  });

  var list = Object.keys(stats).map(function (uid) {
    var s = stats[uid];
    s.winPct = s.games > 0 ? s.wins / s.games : -1;
    return s;
  });

  list.sort(function (x, y) { return y.winPct - x.winPct; });
  return list;
}

// Per-opponent record for one player across a set of matches (any mode).
// Each match credits a result against both players on the opposing team.
export function computeHeadToHead(matches, uid, playerNames) {
  var h2h = {};
  function ensure(oid) {
    if (!h2h[oid]) {
      h2h[oid] = { uid: oid, name: (playerNames && playerNames[oid]) || oid, wins: 0, losses: 0, draws: 0, games: 0 };
    }
  }
  matches.forEach(function (m) {
    if (!m.teamA || !m.teamB) return;
    var onA = m.teamA.indexOf(uid) !== -1;
    var onB = m.teamB.indexOf(uid) !== -1;
    if (!onA && !onB) return;
    var myTeam = onA ? "A" : "B";
    var opponents = onA ? m.teamB : m.teamA;
    opponents.forEach(function (oid) {
      ensure(oid);
      h2h[oid].games++;
      if (!m.winningTeam) { h2h[oid].draws++; }
      else if (m.winningTeam === myTeam) { h2h[oid].wins++; }
      else { h2h[oid].losses++; }
    });
  });
  return Object.keys(h2h).map(function (k) { return h2h[k]; }).sort(function (a, b) { return b.games - a.games; });
}
